import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCreditNoteList } from "@/app_redux/reducers/slices/auth/cart_slice";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentCreditNoteListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletTableInProgress
  const execute = useCallback(
    async (customerId: string, page_num: number, page_size: number) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerCreditNoteTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(
            `${PAYMENT_MODULE?.CREDIT_NOTE_LIST?.baseURL}?user_id=${customerId}&page_number=${page_num}&page_size=${page_size}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              dispatch(setCreditNoteList(res.data.data?.credit_notes_data));

              dispatch(
                setLoading({
                  key: "isCustomerCreditNoteTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              dispatch(
                setLoading({
                  key: "isCustomerCreditNoteTableInProgress",
                  status: false,
                }),
              );
              dispatch(setCreditNoteList([]));

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setCreditNoteList([]));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerCreditNoteTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCustomerCreditNoteTableInProgress",
            status: false,
          }),
        );
        dispatch(setCreditNoteList([]));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
